/**
 * Card Swatches Web Component (Woody's Eyewear style)
 * Hover previews the variant image on the card; swatches are links, so click/tap goes to the variant.
 */
if (!customElements.get('card-swatches')) {
  class CardSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.card-wrapper');
      if (!this.card) return;

      this.items = this.querySelectorAll('.card-swatch-item[data-image-src]');
      if (!this.items.length) return;

      this.mainImg = this.card.querySelector('.card__media .media img:first-of-type');
      if (this.mainImg && !this.mainImg.dataset.originalSrc) {
        this.mainImg.dataset.originalSrc = this.mainImg.getAttribute('src') || '';
        this.mainImg.dataset.originalSrcset = this.mainImg.getAttribute('srcset') || '';
      }

      this.items.forEach((item) => {
        item.addEventListener('mouseenter', () => this.preview(item));
        item.addEventListener('focus', () => this.preview(item));
      });

      this.addEventListener('mouseleave', () => this.restore());
      this.card.addEventListener('mouseleave', () => this.restore());
    }

    preview(item) {
      this.card.classList.add('has-swatch-hover');
      this.setActive(item);
      this.setImage(item.dataset.imageSrc, item.dataset.imageSrcset);
    }

    restore() {
      this.card.classList.remove('has-swatch-hover');
      this.setActive(this.items[0]);
      if (this.mainImg) {
        this.setImage(this.mainImg.dataset.originalSrc, this.mainImg.dataset.originalSrcset);
      }
    }

    setActive(activeItem) {
      this.items.forEach((item) => item.classList.toggle('is-active', item === activeItem));
    }

    setImage(src, srcset) {
      if (!this.mainImg || !src || this.mainImg.getAttribute('src') === src) return;
      this.mainImg.setAttribute('src', src);
      if (srcset) this.mainImg.setAttribute('srcset', srcset);
    }
  }

  customElements.define('card-swatches', CardSwatches);
}
